import { render } from "./ViewCompanyFeedbackDialog.vue?vue&type=template&id=92bb6a66&scoped=true"
import script from "./ViewCompanyFeedbackDialog.vue?vue&type=script&lang=js"
export * from "./ViewCompanyFeedbackDialog.vue?vue&type=script&lang=js"

import "./ViewCompanyFeedbackDialog.vue?vue&type=style&index=0&id=92bb6a66&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92bb6a66"]])

export default __exports__